import { render } from "./CoBrandThemeClassicSplit.vue?vue&type=template&id=5de9d390&scoped=true"
import script from "./CoBrandThemeClassicSplit.vue?vue&type=script&lang=js"
export * from "./CoBrandThemeClassicSplit.vue?vue&type=script&lang=js"

import "./CoBrandThemeClassicSplit.vue?vue&type=style&index=0&id=5de9d390&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de9d390"]])

export default __exports__